import React from 'react';
import AppPage from './page/app.page';
import { Provider } from 'react-redux';
import Store from './redux/store';
import './i18n';
// import ErrorBoundary from './component/error-boundary';
// import DateFnsUtils from '@date-io/date-fns';
// import { MuiPickersUtilsProvider } from '@material-ui/pickers';

export default function App() {

	return (
		<Provider store={Store} >
			{/* <ErrorBoundary projectName={'RBP'}> */}
			{/* <MuiPickersUtilsProvider utils={DateFnsUtils}> */}
			<AppPage />
			{/* </MuiPickersUtilsProvider> */}
			{/* </ErrorBoundary> */}
		</Provider>
	)
}

